import {useSyncExternalStore} from "react";

const mediaQuery = "(prefers-color-scheme: dark)";

function subscribe(callback: () => void) {
    const query = window.matchMedia(mediaQuery);

    query.addEventListener("change", callback);

    return () => {
        query.removeEventListener("change", callback);
    };
}

function getSnapshot() {
    return window.matchMedia(mediaQuery).matches;
}

function getServerSnapshot() {
    return false;
}

export function useSystemTheme() {
    // Replacing the combination of `useEffect` and `useState`
    // https://react.dev/learn/you-might-not-need-an-effect#subscribing-to-an-external-store
    return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
